import JshModule from '@core/scripts/helper/jsh-module';

const { moduleScope } = JshModule('service/service-tabs');

if (moduleScope) {
    const tabsContainer = moduleScope;
    const navItems = tabsContainer.querySelectorAll('.service-page-tabs__nav-item');
    const panels = tabsContainer.querySelectorAll('.service-page-tabs__panel');

    // Mark as JS-enhanced — CSS switches from :target mode to .is-active mode
    tabsContainer.classList.add('js-tabs-initialized');

    const activateBySlug = (slug) => {
        const targetItem = tabsContainer.querySelector(`.service-page-tabs__nav-item[data-tab-slug="${slug}"]`);
        if (!targetItem) return false;

        const index = targetItem.dataset.tabIndex;
        navItems.forEach((nav) => nav.classList.remove('is-active'));
        panels.forEach((panel) => panel.classList.remove('is-active'));
        targetItem.classList.add('is-active');
        tabsContainer.querySelector(`.service-page-tabs__panel[data-tab-index="${index}"]`)?.classList.add('is-active');
        return true;
    };

    // Handle tab clicks — prevent default anchor behavior to avoid history.js interference
    navItems.forEach((item) => {
        const link = item.querySelector('a');
        if (link) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const slug = item.dataset.tabSlug;
                if (activateBySlug(slug) && slug) {
                    // Silently update the URL hash without triggering popstate
                    window.history.replaceState(null, '', `#${slug}`);
                }
            });
        }
    });

    const activateFromHash = () => {
        const slug = window.location.hash.slice(1);
        if (slug) activateBySlug(slug);
    };
    activateFromHash();
    window.addEventListener('hashchange', activateFromHash);
}
